import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    '.Header-Root': {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      flexDirection: {
        xs: 'column',
        md: 'row',
      },
    },
    '.Title-Container': {
      display: 'flex',
      alignItems: 'center',
      gap: (theme) => theme.spacing(2),
      '.MuiTypography-root': {
        padding: 0,
      },
    },
    '.Title-Icon': {
      cursor: 'pointer',
    },
    '.Export-Button': { marginLeft: '10px' },
  },
});

export default useSx;
